export default {
  reveseral_amount: '冲正金额',
  account_overview: '账户总览',
  balance: '余额',
  balance_available: '可用余额',
  top_up: '充值',
  cash_out: '提现',
  settlement_cycle: '结算周期', // 会计总览页
  settlement_amount: '结算金额',
  transactions_number: '交易笔数',
  transaction_status: '交易状态',
  transaction_date: '交易日期', // 支付交易明细
  response_date: '回调结果日期', // 回调结果日期
  transaction_type: '交易类型',
  update_time: '更新时间',
  withdraw_time: '提现时间',
  recharge_time: '充值时间',
  details: '详情',
  details_excel_download: '明细excel下载',
  merchant_order_id: '商户订单号',
  transaction_id: '交易编号',
  pay_trans_id: '支付流水号',
  po_trans_id: '付款流水号', // 代付交易明细
  create_time: '创建时间',
  complete_time: '完成时间',
  recipient_name: '收款人名称',
  recipient_id_type: '证件类型',
  recipient_id: '证件ID',
  recipient_birth_date: '出生年月',
  recipient_mobile: '联系方式',
  recipient_channel: '收款渠道',
  recipient_account: '收款人账户',
  account_holder_name: '账户持有人姓名',
  account_no: '收款账号',
  recipient_card: '收款人账户',
  money_source: '资金来源',
  po_fee: '服务费',
  po_trans_status: '交易状态',
  po_fee_plan_id: '代付手续费模板ID',
  cash_out_date: '提现日期', // 提现记录界面
  amount: '金额',
  operator: '操作人',
  status: '状态',
  note: '备注',
  balance_record_type: '变动类目',
  init_balance: '初始余额',
  balance_record_id: '余额记录ID',
  transaction_amount: '交易金额',
  balance_record_status: '余额记录状态',
  current_balance: '当前余额',
  remitter_information: '汇款人信息',
  payee_information: '收款人信息',
  enter_recharge_amount: '请输入充值金额',
  enter_withdraw_amount: '请输入提现金额',
  withdrawal_account_information: '提现账户信息',
  bank: '银行名称',
  bank_account: '银行账号',
  bank_account_name: '银行账户持有人',
  bank_address: '银行地址',
  in_transit_settlement_amount: '在途结算金额',
  amount_in_transit: '在途金额',
  amount_adb: 'ADB金额',
  branch_no: '网点编码',
  courier_no: '快递员编码',
  region_no: '大区编码',
  beneficiary_name: '收款人名称',
  beneficiary_mobile: '收款人手机号',
  beneficiary_email: '收款人邮箱',
  beneficiary_iban: '收款人IBAN账号',
  beneficiary_swift_code: 'SWIFT Code',
  beneficiary_bank_address: '收款银行地址',
  beneficiary_en_first_name: '收款方英文名字',
  beneficiary_en_last_name: '收款方英文姓氏',
  beneficiary_native_first_name: '收款方本国名字',
  beneficiary_native_last_name: '收款方本国姓氏',
  beneficiary_account_type: '收款账户类型',
  account_type: '收款账户类型',
  account_type_mobile_number: '手机号',
  account_type_ewallet_id: '电子钱包',
  beneficiary_type: '收款人类别',
  beneficiary_category: '收款人主体类别',
  beneficiary_category_placeholder: '请选择收款人主体类别',
  beneficiary_category_required: '收款人主体类别不能为空',
  beneficiary_category_individual: '个人',
  beneficiary_category_organization: '公司',
  recipient_account_type: '收款人账户类型',
  short_name: '简称',
  receiving_channel: '收款渠道',
  amount_limit: '剩余额度',
  beneficiary_account_no: '收款账号',
  expire_time: '过期时间',
  review_comments: '审核意见',
  available_balance: '可用余额',
  beneficiary: '收款人',
  beneficiary_channel: '收款人渠道',
  beneficiary_account: '收款人账户',
  beneficiary_id: '收款人编号',
  add_a_beneficiary: '添加收款人',
  permanent: '永久有效',
  account_details: '账户详情',
  information_details: '详情',
  other: '其他',
  attachments: '附件',
  beneficiary_details: '收款人详情',
  payment_details: '付款详情',
  beneficiary_account_information: '收款账户信息',
  basic_company_information_of_beneficiary: '收款方公司信息',
  full_legal_entity_name_of_beneficiary: '收款方公司名',
  registered_country: '注册国家',
  registered_address: '注册地址',
  authorized_representative: '授权代表人',
  signature_of_the_beneficiary: '收款人签字',
  full_name: '姓名',
  position: '职位',
  click_to_sign: '点击签名',
  payment_description: '付款说明',
  cash_out_threshold: '提现门槛',
  nsds_bill_summary: 'NSDS账单汇总',
  amount_used: 'NSDS使用金额待偿付',
  service_fee: 'NSDS服务费待偿付',
  repayment_details: '偿付详情',
  repayment_plan_amount: '计划偿付',
  discount: '可享受优惠',
  total: '总计',
  go_to_pay: '去偿付',
  bill_date: '账单日期',
  currency: '币种',
  nsds_usage_date: 'NSDS使用日期',
  nsds_usage_amount: 'NSDS使用金额',
  nsds_service_fee: 'NSDS服务费',
  billing_type: '计费类型',
  bill_total_amount: '账单总额',
  paid_amount: '已偿付',
  pending_amount: '待偿付',
  settled: '已结清',
  unsettled: '未结清',
  bill_status: '账单状态',
  nsds_payment_amount: 'NSDS 付款金额',
  discount_tip_1: 'D日使用NSDS资金产生的服务费，在D+1日配置偿付时间（比如',
  discount_tip_2: '）之前偿付本金，且当前账单完全偿付。可享受免服务费服务。',
  settlement_date: '结清日期',
  per_transaction: '逐笔',
  per_day: '逐日',
  payment_remark: '付款备注',
  cancel_cash_out: '取消提现',
  cancel_reason: '取消原因',
  confirm_cash_out: '确认提现',
  cancel_reason_placeholder: '请输入取消原因……',
  cancel_reason_required: '取消原因不能为空',
  cancel_reason_length: '长度应为1到200个字符'
}
